import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Menu,
  MenuItem,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TermsModal from './termModal';
import TermInstructionsDialog from './termInstructionsDialog';
import TermDeleteDialog from './termDeleteDialog';
import Loading from '../../components/loading';
import SuccessMessage from '../../components/successMessage';
import ErrorMessage from '../../components/errorMessage';
import { useTermsScreen } from './hooks/useTermsScreen';

function TermsWeb() {
  const {
    terms,
    isLoading,
    deleteTerm,
    downloadTerm,
    onSavedTerm,
    showSuccessMessage,
    setShowSuccessMessage,
    successMessage,
    showErrorMessage,
    setShowErrorMessage,
    errorMessage,
  } = useTermsScreen();

  const [openInstructions, setOpenInstructions] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [termToDelete, setTermToDelete] = useState(null);

  const menuOpen = (event, term) => {
    setAnchorEl(event.currentTarget);
    setSelectedTerm(term);
  };

  const menuClose = () => {
    setAnchorEl(null);
    setSelectedTerm(null);
  };

  const closingInstructions = () => {
    setOpenInstructions(false);
    setOpenModal(true);
  };

  const download = () => {
    if (selectedTerm) {
      downloadTerm(selectedTerm.id);
    }
    menuClose();
  };

  const handleDeleteClick = () => {
    setTermToDelete(selectedTerm);
    setAnchorEl(null);
  };

  const handleConfirmDelete = () => {
    deleteTerm(termToDelete.id).then(() => {
      setTermToDelete(null);
      setSelectedTerm(null);
    });
  };

  const savedTerm = (returnFromApi) => {
    onSavedTerm(returnFromApi);
    setOpenModal(false);
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Loading isToHidden={isLoading === false} />
      {showSuccessMessage && (
        <SuccessMessage
          message={successMessage}
          show={showSuccessMessage}
          setShow={setShowSuccessMessage}
        />
      )}
      {showErrorMessage && (
        <ErrorMessage
          message={errorMessage}
          show={showErrorMessage}
          setShow={setShowErrorMessage}
        />
      )}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5" sx={{ mb: 0, fontWeight: 'bold', color: 'text.secondary' }}>
          Configuração de Termos
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end' }}>
          <Button variant="outlined" onClick={() => setOpenInstructions(true)}>
            Adicionar Termo
          </Button>
        </Box>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Descrição</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Data de Cadastro</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {terms.length === 0 && !isLoading ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
                  Nenhum termo cadastrado ainda.
                </TableCell>
              </TableRow>
            ) : (
              terms.map((term) => (
                <TableRow key={term.id} hover>
                  <TableCell>{term.description}</TableCell>
                  <TableCell>{term.date}</TableCell>
                  <TableCell align="right">
                    <IconButton aria-label="ações" onClick={(event) => menuOpen(event, term)}>
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Menu id="actions-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={menuClose}>
        <MenuItem onClick={download}>Baixar .docx</MenuItem>
        <MenuItem onClick={handleDeleteClick} sx={{ color: 'error.main' }}>
          Excluir
        </MenuItem>
      </Menu>

      <TermDeleteDialog
        open={Boolean(termToDelete)}
        termDescription={termToDelete?.description}
        onCancel={() => {
          setTermToDelete(null);
          setSelectedTerm(null);
        }}
        onConfirm={handleConfirmDelete}
      />

      <TermInstructionsDialog open={openInstructions} onClose={closingInstructions} />

      <TermsModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSave={savedTerm}
        currentTerm={null}
      />
    </Box>
  );
}

export default TermsWeb;
